import { useRef, useState, useCallback } from "react"
import { postRequest, postRequestNoneKey } from 'utils/_function';
import axios from 'axios';

// マップ画面からラスター画像を格納したzipファイルをS3にアップロードする処理
export const useAddRasterImgData = (setMapLoading, projectId, accountGroupId, fetchMapLayers, setMapLayerState) => {
  const [selectedRasterFile, setSelectedRasterFile] = useState(null); // アップロードするzipファイルのデータを格納
  const [uploadRasterName, setUploadRasterName] = useState(""); // アップロードするラスターデータ名を格納
  const [rasterNameInputModalIsOpen, setRasterNameInputModalIsOpen] = useState(false); // ラスター名入力モーダルの開閉を制御
  const [rasterEditDeleteState, setRasterEditDeleteState] = useState({rasterId: "", rasterName: ""}); // ラスタの編集削除に必要な情報を格納
  const [upDateRasterName, setUpDateRasterName] = useState(""); // 更新するラスタ名を格納
  const fileInputRef = useRef(null);

  // ファイル選択UIを表示
  const handleClickUploadBtn = useCallback(() => fileInputRef.current.click(), [])

  // ラスターデータ(zip)ファイルを選択した際の処理
  const handleChangeSelectRasterFile = useCallback((e, value) => {
    
    const fileData = e.target.files[0];    
    const extension = fileData.name.split('.').pop();

    // 選択したファイルの拡張子がgeojsonでもzipでもないときは処理を停止
    if (extension !== "geojson" && extension !== "zip") {
      setSelectedRasterFile(null); // アップロードしたファイルを初期化
        alert('アップロード可能なファイルは.geojsonもしくは.zipのみです。')
      return;
    }

    if (fileData){
      setSelectedRasterFile(e.target.files[0]);
      if (value === "add") setRasterNameInputModalIsOpen(true); // 名前入力モーダルを表示
    }else{
      setSelectedRasterFile(null);
      if (value === "add") setRasterNameInputModalIsOpen(false); // 名前入力モーダルを非表示
    }
  }, [])

  // ラスターデータ名入力モーダル非表示にする処理
  const handleClickRasterNameInputModalClose = useCallback(() => {
    setRasterNameInputModalIsOpen(false); // 名前入力モーダルを非表示
  })

  // ラスター名を入力した際のイベント処理
  const handleClickRasterNameInput = useCallback((e) => setUploadRasterName(e), [])
  const handleClickRasterNameUpdateInput = useCallback((value) => {
    setUpDateRasterName(value);
  },[])

  // ラスターの編集ボタンをクリックした際の処理
  const handleClickRasterEditBotton = useCallback((e) => {
    setRasterEditDeleteState({
      rasterId: e.rasterId,
      rasterName: e.rasterName
    });
    setUpDateRasterName(e.rasterName);
  },[])
  
  // ラスターデータ名入力モーダル非表示にする処理
  const handleClickRasterEditModalClose = useCallback(() => {
    setRasterEditDeleteState({
      rasterId: "",
      rasterName: ""
    });
    setUpDateRasterName("");
  })

  // ラスターを削除する処理
  const handleClickDeleteRaster = useCallback(async (rasterId, projectId, rasterName) => {
    setMapLoading(true); // ローディング開始
    const params = {
      projectId: String(projectId),
      rasterId: String(rasterId),
    };
    const response = await postRequest('IM_Lambda', '/im_deleterasterinfo', params);
    switch (response.statusCode) {
      case "N0000": // 正常終了
        fetchMapLayers(); // 再度ラスタの一覧を取得しドロワメニューに反映する
        break;
      default:
        alert(`「${rasterName}」の削除に失敗しました。`);
        break;
    }
    // 表示中のラスタは一旦すべて非表示
    setMapLayerState((prevData) =>
      prevData.map((item) => ({
        ...item,
        state: false, // stateを強制的にfalseに設定
      }))
    );
    setMapLoading(false); // ローディング終了
    handleClickRasterEditModalClose(); // 名前入力モーダルを非表示
  }, []);

  // 署名付きURLを発行するAPIを実行しそのまま選択したファイルをS3にアップロード
  const fetchRasterDataPutS3 = async (rasterName, selectedRasterFile, rasterId, extension) => {
    const params = {
      projectId: String(projectId),
      AccountGroupId: String(accountGroupId),
      rasterName: String(rasterName),
      ...(rasterId && { rasterId: String(rasterId) }), // rasterId が存在する場合は更新
      extension: String(extension)
    }
    
     // 署名付きURL発行してファイルをS3にアップロード
    const response = await postRequestNoneKey('IM_Lambda', '/im_addrasterdata', params);

    // Content-Typeを動的に変更
    let fileType = "";
    if (extension === "geojson"){
      fileType = "application/geo+json"
    }else if (extension === "zip"){
      fileType = "application/zip"
    }
    
    switch (response.statusCode) {
      case 200: // 正常終了
        // 更新したいzipが選択されている場合はs3にPUT
        if (selectedRasterFile){
          await axios.put(response.body.signed_url, selectedRasterFile, {
            headers: {
              'Content-Type': fileType
            }
          });
        }
        break;
      default:
        // レイヤ名の変更時の動作
        setSelectedRasterFile(null); // アップロードしたファイルを初期化
        setMapLoading(false); // ローディング終了
        break;
    }

    // 表示中のラスタは一旦すべて非表示
    setMapLayerState((prevData) =>
      prevData.map((item) => ({
        ...item,
        state: false, // stateを強制的にfalseに設定
      }))
    );
    fetchMapLayers(); // 再度ラスタの一覧を取得しドロワメニューに反映する
    setSelectedRasterFile(null); // アップロードしたファイルを初期化
    setMapLoading(false); // ローディング終了
  }

  // 新規ラスター名決定時の処理
  const handleClickRasterDataPutS3 = useCallback(() => {
    if (uploadRasterName === "") return; // 入力値が空の場合は処理を停止
    setMapLoading(true); // ローディング開始
    setRasterNameInputModalIsOpen(false); // 名前入力モーダルを非表示

    // ファイルの拡張子を取得
    const extension = selectedRasterFile.name.split('.').pop();
    fetchRasterDataPutS3(uploadRasterName, selectedRasterFile, null,  extension); // ファイルアップロード

  }, [uploadRasterName, selectedRasterFile])

  // 既存ラスターを更新する処理
  const handleClickUpdateRaster = useCallback(() => {
     // 入力値が空の場合は処理を停止
    if (upDateRasterName === ""){
      alert('レイヤーを入力してください');
      return;
    };

    // 名前入力モーダルを非表示
    handleClickRasterEditModalClose();

    // ファイルの拡張子を取得し更新前のファイルと同一かチェックする
    let extension = null;
    if (selectedRasterFile !== null) {
      extension = selectedRasterFile.name.split('.').pop();

      let fileType = "";
      if (rasterEditDeleteState.rasterId.startsWith("poly_")){
        fileType = "geojson"
      }else if(rasterEditDeleteState.rasterId.startsWith("tile_")){
        fileType = "zip"
      }else{
        fileType = "zip"
      }

      if (fileType !== extension) {
        alert('元のファイルと同じ拡張子のファイルで更新してください');
        setSelectedRasterFile(null); // アップロードしたファイルを初期化
        return;
      }
    }

    setMapLoading(true); // ローディング開始
    fetchRasterDataPutS3(upDateRasterName, selectedRasterFile, rasterEditDeleteState.rasterId, extension); // ファイルアップロード

  },[upDateRasterName, selectedRasterFile, rasterEditDeleteState])

  //独自レイヤーの不透明度を定義
  const [uniqueMapLayerOpacity, setUniqueMapLayerOpacity] = useState(60);
  const handleChangeUniqueMapLayerOpacity = useCallback((event, newValue) => setUniqueMapLayerOpacity(newValue));

  return {
    fileInputRef,
    rasterNameInputModalIsOpen,
    rasterEditDeleteState,
    upDateRasterName,
    uniqueMapLayerOpacity,
    handleChangeSelectRasterFile,
    handleClickRasterNameInputModalClose,
    handleClickRasterNameInput,
    handleClickRasterDataPutS3,
    handleClickUploadBtn,
    handleClickRasterEditBotton,
    handleClickRasterEditModalClose,
    handleClickUpdateRaster,
    handleClickDeleteRaster,
    handleClickRasterNameUpdateInput,
    handleChangeUniqueMapLayerOpacity
  }
}